import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import Grid from 'apollo-react/components/Grid';
import LinearProgress from 'apollo-react/components/LinearProgress';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import withTranslation from '../withTranslation';

const useStyles = makeStyles({
  progressLabel: {
    color: colors.black,
    fontWeight: 600,
    fontSize: 14,
    display: 'block',
  },
  linearProgressRoot: {
    height: 8,
    borderRadius: 7,
  },
  linearProgressColorPrimary: {
    backgroundColor: colors.neutral4,
  },
  linearProgressBarColorPrimary: {
    backgroundColor: colors.utilityPositive,
  },
});

const TaskStatusCardProgress = ({
  completedSubtasksCount,
  totalSubtasksCount,
  translateString,
}) => {
  const classes = useStyles();

  return (
    <Grid container justify="space-between" alignItems="center">
      <Grid item xs={10}>
        <LinearProgress
          classes={{
            root: classes.linearProgressRoot,
            colorPrimary: classes.linearProgressColorPrimary,
            barColorPrimary: classes.linearProgressBarColorPrimary,
          }}
          variant="determinate"
          value={Math.round((completedSubtasksCount / totalSubtasksCount) * 100)}
        />
      </Grid>
      <Grid item xs={2}>
        <Typography className={classes.progressLabel} variant="caption" align="right">
          {`${completedSubtasksCount} ${translateString('of')} ${totalSubtasksCount}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default withTranslation(TaskStatusCardProgress);
